import {HtmlInfo} from '../type/HtmlInfo.interface';
import {PartialFrameElements} from '../type/PartialFrameElements.interface';

/**
 * 다운로드 받은 컨텐츠 데이터(html, style)를 frameElements에 붙이는 함수
 */
export function applyHtmlInfo({
  frameElements,
  htmlInfo,
}: {
  frameElements: PartialFrameElements;
  htmlInfo: HtmlInfo;
}) {
  const {styleElement, contentElement} = frameElements;
  const {html, style} = htmlInfo;

  // 간혹 콘텐츠 자체적으로 !important 옵션을 준 폰트가 있어서 공통 폰트 설정보다 우선순위를 가지는 경우가 있습니다.
  // 어차피 콘텐츠의 모든 폰트를 지원하는 상황이 아니므로 특정 폰트로 강제해야합니다.
  // 이런 이유로, 스타일 코드에 font-family 가 있으면 제거합니다.
  styleElement.innerHTML = style.replace(/font-family\s*:.*?((?=})|;)/g, '');
  contentElement.innerHTML = html;
}
